export default "__VITE_ASSET__CZe8QOMP__"